module.exports = __webpack_public_path__ + "img/ic-btn-sms.74a59d55.svg";